import { AppRouteDefinition } from '../routeDefinition';
import { aclRoutes } from './aclRoutes';
import { protocolRoutes } from './protocolRoutes';
import { ictRoutes } from './ictRoutes';
import { filedSettlementRoutes } from './filedSettlementRoutes';
import { legalReportRoutes } from './legalReportRoutes';
import { mjeMenuRoutes } from './mjeRoutes';
import { csnuRoutes } from './csnuRoutes';
import { cashBackRoutes } from './cashBackRoutes';
import { cashPaymentRoutes } from './cashPaymentRoutes';
import { stnReportRoutes } from './stnReportRoutes';

export const menuProtectedRoutes: AppRouteDefinition[] = [
  ...aclRoutes,
  ...protocolRoutes,
  ...ictRoutes,
  ...filedSettlementRoutes,
  ...legalReportRoutes,
  ...mjeMenuRoutes,
  ...csnuRoutes,
  ...cashBackRoutes,
  ...cashPaymentRoutes,
  ...stnReportRoutes,
];
